import { render, staticRenderFns } from "./TestBattleProfile.vue?vue&type=template&id=4b0e89e0"
import script from "./TestBattleProfile.vue?vue&type=script&lang=js"
export * from "./TestBattleProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports